const restclient = require('nordic/restclient');
const { getFeedbackBaseAPIURL } = require('dx-feedback-utils');

module.exports = function createHTTPClient() {
  return restclient({
    timeout: 5000,
    baseURL: getFeedbackBaseAPIURL(window.location.host),
  });
};
